import { Box, Link as MuiLink, useTheme } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

type BlogMarkdownProps = {
  content: string;
};

export const BlogMarkdown = ({ content }: BlogMarkdownProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        '& p': {
          typography: 'body1',
          color: 'text.secondary',
          lineHeight: 1.85,
          mb: 2,
        },
        '& h1': { display: 'none' },
        '& h2': {
          typography: 'h5',
          fontWeight: 700,
          mt: 4,
          mb: 1.5,
          color: 'text.primary',
        },
        '& h3': {
          typography: 'h6',
          fontWeight: 700,
          mt: 3,
          mb: 1,
          color: 'text.primary',
        },
        '& ul, & ol': { pl: 2.5, mb: 2, color: 'text.secondary' },
        '& li': { mb: 0.75, lineHeight: 1.75 },
        '& a': { color: 'primary.main', fontWeight: 600 },
        '& strong': { color: 'text.primary', fontWeight: 700 },
        '& blockquote': {
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          pl: 2,
          my: 2,
          color: 'text.secondary',
          fontStyle: 'italic',
        },
        '& code': {
          bgcolor: 'action.hover',
          px: 0.5,
          borderRadius: 0.5,
          fontSize: '0.9em',
        },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ href, children }) => (
            <MuiLink
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {children}
            </MuiLink>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};
